import { DjangoTimeStamped, TimeStamped } from './../django/time-stamped.model';
import { parseDate } from './../helpers/date';

export class ProposalSigners implements TimeStamped {
  borrowerId: string;
  created: Date;
  lenderId: string;
  modified: Date;
  phoneNumber: string;

  constructor(data: ProposalSigners | DjangoProposalSigners = {}) {
    bindProposalSignersData(this, data);
  }
}

export interface DjangoProposalSigners extends DjangoTimeStamped {
  borrower_id?: string;
  created?: string;
  lender_id?: string;
  modified?: string;
  phone_number?: string;
}

export function parseProposalSigners(data: ProposalSigners | DjangoProposalSigners) {
  if (data) {
    return new ProposalSigners(data);
  } else {
    return undefined;
  }
}

function bindProposalSignersData(
  proposalSigners: ProposalSigners,
  data: ProposalSigners | DjangoProposalSigners,
) {
  const djangoData = data as DjangoProposalSigners;
  const jsData = data as ProposalSigners;
  // BINDINGS
  proposalSigners.borrowerId = djangoData.borrower_id || jsData.borrowerId;
  proposalSigners.created = parseDate(data.created);
  proposalSigners.lenderId = djangoData.lender_id || jsData.lenderId;
  proposalSigners.modified = parseDate(data.modified);
  proposalSigners.phoneNumber = djangoData.phone_number || jsData.phoneNumber;
}
